import { Search, X } from "lucide-react";
import CollapsibleFilters from "@/components/shared/CollapsibleFilters";
import { DateRangeBar } from "@/components/ListTools";

const ACTOR_TYPES = [["admin", "Administrateur"], ["portal", "Client (portail)"], ["public", "Visiteur (lien public)"], ["system", "Système / webhook"], ["anonymous", "Anonyme"]];
const sel = "border border-slate-300 rounded-lg px-2 py-2 sm:py-1.5 text-xs bg-white w-full md:w-auto";

export default function AuditFilters({ f, setF, facets, count, reset }) {
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const active = Object.entries(f).filter(([k, v]) => v && k !== "q").length;
  return (
    <CollapsibleFilters testId="audit-filters" active={active}
      always={
        <>
          <div className="relative flex-1 min-w-[200px]">
            <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input value={f.q} onChange={set("q")} placeholder="Rechercher (acteur, détail, dossier, erreur…)" className="w-full border border-slate-300 rounded-lg pl-8 pr-3 py-2 sm:py-1.5 text-xs" data-testid="audit-search" />
          </div>
          <span className="text-xs text-slate-500 whitespace-nowrap" data-testid="audit-count">{count ?? "—"} entrée{count > 1 ? "s" : ""}</span>
        </>
      }>
      <select value={f.actor_id ? `id:${f.actor_id}` : f.actor_type ? `type:${f.actor_type}` : ""} onChange={(e) => { const v = e.target.value; setF((p) => ({ ...p, actor_id: v.startsWith("id:") ? v.slice(3) : "", actor_type: v.startsWith("type:") ? v.slice(5) : "" })); }} className={`${sel} md:max-w-[220px]`} data-testid="audit-filter-actor">
        <option value="">Tous les acteurs</option>
        <optgroup label="Type">{ACTOR_TYPES.map(([k, l]) => <option key={k} value={`type:${k}`}>{l}</option>)}</optgroup>
        {facets.actors.length > 0 && <optgroup label="Personnes">{facets.actors.map((a) => <option key={`${a.type}-${a.id}`} value={`id:${a.id}`}>{`${a.label} (${a.type === "admin" ? "admin" : "portail"}) · ${a.count}`}</option>)}</optgroup>}
      </select>
      <select value={f.module} onChange={set("module")} className={sel} data-testid="audit-filter-module">
        <option value="">Tous les modules</option>
        {facets.modules.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
      <select value={f.action} onChange={set("action")} className={sel} data-testid="audit-filter-action">
        <option value="">Toutes les actions</option>
        {facets.actions.map((a) => <option key={a.id} value={a.id}>{a.label}</option>)}
      </select>
      <select value={f.ok} onChange={set("ok")} className={sel} data-testid="audit-filter-ok">
        <option value="">Réussies et refusées</option>
        <option value="true">Réussies seulement</option>
        <option value="false">Refusées / erreurs</option>
      </select>
      <DateRangeBar from={f.date_from} to={f.date_to} onChange={(r) => setF((p) => ({ ...p, date_from: r.from, date_to: r.to }))} testId="audit-date" />
      {f.entity_id && (
        <span className="inline-flex items-center gap-1 text-[11px] bg-sky-50 border border-sky-200 text-sky-800 rounded-lg px-2 py-1" data-testid="audit-entity-chip">
          Entité #{f.entity_id.slice(0, 8)} <button onClick={() => setF((p) => ({ ...p, entity_id: "" }))} aria-label="Retirer" data-testid="audit-entity-chip-clear"><X className="w-3 h-3" /></button>
        </span>
      )}
      {active > 0 && <button onClick={reset} className="text-xs text-slate-500 hover:text-slate-800 underline whitespace-nowrap" data-testid="audit-filters-reset">Effacer les filtres</button>}
    </CollapsibleFilters>
  );
}
